'use es6';

import { createStore, applyMiddleware, compose } from 'redux';
import rootReducer from '../reducers';
export default function configureStore(middleware = []) {
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const storeWithMiddleWare = composeEnhancers(applyMiddleware(...middleware))(createStore);
  return storeWithMiddleWare(rootReducer);
}